import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Attachment } from 'utils/types';
import { useParams } from 'react-router';

import c from '../utils/constants';

interface Payload {
  id: string;
  payload: {
    attachments?: Attachment[];
    content: string;
  };
  referenceId: string;
  parentId?: string;
}

export default function useUpdateNote() {
  const params = useParams();
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useMutation({
    mutationFn: async ({ id, payload, parentId, referenceId }: Payload) => {
      const api = new Api(args);

      const data = await api.patch(
        await withAcl({
          account: {
            url: `api/v1/comments/${id}`,
            payload,
            params: { parentId, referenceId, id },
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/comments/${id}`,
            payload,
            params: { parentId, referenceId, id },
          },
        }),
      );

      return data;
    },
    onSuccess: (_, { referenceId, parentId }) => {
      if (parentId) {
        queryClient.invalidateQueries({
          queryKey: [c.NOTES, parentId, c.NOTE_COMMENT],
        });
      }

      queryClient.invalidateQueries({
        queryKey: [c.NOTES, referenceId],
      });

      queryClient.invalidateQueries({
        queryKey: [c.LOGS, params.id ?? referenceId],
      });

      toastSuccess('Successfully updated note');
    },
  });
}
